import { GroundCommonContent } from "../../../../modules/content/components/GroundCommonContent/GroundCommonContent";
import { GroundMedia } from "../../../../modules/content/components/GroundMedia/GroundMedia";
import { GroundSection } from "../../../../modules/content/components/GroundSection/GroundSection";
import type { IImageBlockProps } from "./ImageBlock.props";

export const ImageBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  image,
  parentClass,
  spacing,
}: IImageBlockProps) => {
  if (!image) return null;

  return (
    <GroundSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-8 md:gap-12">
        <GroundCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <GroundMedia
          aspectRatio={image.aspectRatio}
          media={image.image}
          sizes="(min-width: 1280px) 1184px, calc(100vw - 48px)"
        />
      </div>
    </GroundSection>
  );
};

ImageBlock.displayName = "Block::ImageBlock";
